import { useEffect, useState, type FormEvent } from 'react';
import type { TranslationCatalog } from '../../lib/widget-translations';
import { SendIcon } from './widget-icons';
import styles from './widget-preview.module.scss';

interface MessageComposerProps {
  disabled: boolean;
  resetSignal: number;
  translations: TranslationCatalog;
  messageAriaLabel: string;
  onSend: (message: string) => void;
}

export const MessageComposer = ({
  disabled,
  resetSignal,
  translations,
  messageAriaLabel,
  onSend,
}: MessageComposerProps) => {
  const [value, setValue] = useState('');

  useEffect(() => setValue(''), [resetSignal]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const message = value.trim();
    if (!message || disabled) return;
    onSend(message);
    setValue('');
  };

  return (
    <form className={styles.composer} onSubmit={handleSubmit}>
      <input
        value={value}
        disabled={disabled}
        placeholder={translations.inputPlaceholder}
        onChange={(event) => setValue(event.target.value)}
        aria-label={messageAriaLabel}
      />
      <button
        type="submit"
        disabled={disabled || !value.trim()}
        aria-label={translations.sendMessageAriaLabel}
      >
        <SendIcon />
      </button>
    </form>
  );
};
